module.exports = __webpack_public_path__ + "static/media/doc-6.fe3d5000.jpg";